import type { Vehicle } from '@cobliteam/common-types';
import { Tooltip } from '@cobliteam/ui/components';
import Checkbox from '@cobliteam/ui/form/Checkbox';
import Label from '@cobliteam/ui/form/Label';

import Icon from '@cobliteam/ui/icons';
import { cn } from '@cobliteam/ui/utils';

interface VehicleItemProps {
  checked: boolean;
  data: Vehicle;
  disabled?: boolean;
  disabledTooltip?: React.ReactNode | string;
  grouped?: boolean;
  onChange: () => void;
}

const VehicleItem = ({ checked, data, disabled, disabledTooltip, grouped, onChange }: VehicleItemProps) => {
  const { id } = data;

  const renderAssociationIcon = () => {
    const { deviceId } = data;
    const hasDeviceAssociated = !!deviceId;

    if (hasDeviceAssociated) {
      return (
        <Tooltip content='Associado' position='bottom' align='start' portal={false}>
          <Icon name='link' className='text-primary' />
        </Tooltip>
      );
    }

    return (
      <Tooltip content='Não Associado' position='bottom' align='start' portal={false}>
        <Icon name='unlink' className='text-gray-dark' />
      </Tooltip>
    );
  };

  const brand = data.model.brand ? `- ${data.model.brand}` : '';
  const model = data.model.name ? ` ${data.model.name}` : '';
  const alias = data.alias ? ` (${data.alias})` : '';
  const newLabel = `${data.licensePlate} ${brand} ${model}${alias}`;

  if (disabledTooltip) {
    return (
      <div className='mr-2 flex items-center gap-2'>
        <Tooltip content={disabledTooltip} position='right' align='start' enable={disabled}>
          <div className='mr-2 flex items-center gap-2'>
            <Checkbox id={`${id}-vehicle-item`} key={`${id}-vehicle-item`} checked={checked} onCheckedChange={onChange} disabled={disabled} />
            <Label htmlFor={`${id}-vehicle-item`} className='line-clamp-1 text-start'>
              {data.label}
            </Label>
          </div>
        </Tooltip>
        {renderAssociationIcon()}
      </div>
    );
  }

  return (
    <div className={cn('mr-2 flex items-center gap-2', { 'ml-3': grouped })}>
      <Checkbox id={`${id}-vehicle-item`} key={`${id}-vehicle-item`} checked={checked} onCheckedChange={onChange} title={newLabel} className='line-clamp-1' disabled={disabled} />
      <Label htmlFor={`${id}-vehicle-item`} className='line-clamp-1' title={newLabel}>
        {newLabel}
      </Label>
      {renderAssociationIcon()}
    </div>
  );
};

export default VehicleItem;
